import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { blockRecentProfessional } from '~/actions';
import { IconButton } from '~/commonComponents/IconButton';
import { colors } from '@tempmee/tailwind';
import blockIcon from '~/images/block-user.svg';
import { Row } from '@tempmee/react';
import { ConfirmPopup } from '~/commonComponents';
import BlockCrossIcon from '~/images/icons/BlockCrossIcon';
import { InviteButton } from '../InviteButton';
import { IProfessionalCardUser } from '../../interfaces';
import WarningIcon from '~/images/warning-icon.svg';
import { useCheckPaymentExpiration } from '~/components/Inbox/Notification/Reminders/hooks/useCheckPaymentExpiration';
import { useUserSelector } from '~/hooks/useUserSelector';
import history from '~/browserHistory';
import { routes } from '~/routes';

interface IProfessionalCardActionsLegacyProps {
  user: IProfessionalCardUser;
}

export const ProfessionalCardActionsLegacy = ({
  user: cardUser,
}: IProfessionalCardActionsLegacyProps) => {
  const dispatch = useDispatch();
  const user = useUserSelector();
  const [showConfirmBlockPopup, setShowConfirmBlockPopup] = useState(false);
  const [showMissingPaymentPopup, setShowMissingPaymentPopup] = useState(false);

  const { isExpired, payments } = useCheckPaymentExpiration();

  const isUserPreApproved = user?.is_pre_approved;

  return (
    <Row justify="center" align="center" gap={6} style={{ marginLeft: 24, marginRight: 30 }}>
      <InviteButton
        user={{
          id: cardUser?.id,
          image: cardUser?.profileImage,
          name: cardUser?.fullname,
          profession: cardUser?.profession,
          professions: cardUser?.professions,
          isRecommendedPros: true,
        }}
        onValidate={() => {
          if (!isUserPreApproved && (!payments?.length || isExpired)) {
            setShowMissingPaymentPopup(true);
            return false;
          }
          return true;
        }}
        disabled={!cardUser?.isAvailable}
        source="new_to_you"
      />
      <IconButton
        buttonStyle={{
          display: 'flex',
          height: 50,
          width: 50,
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '50%',
          backgroundColor: cardUser?.isAvailable ? colors.neutral[400] : colors.neutral[200],
        }}
        imgStyle={{ width: 24, height: 24 }}
        src={blockIcon}
        tooltipContent="Block"
        onClick={() => setShowConfirmBlockPopup(true)}
        disabled={!cardUser?.isAvailable}
      />

      {showConfirmBlockPopup && (
        <ConfirmPopup
          title="Block Professional"
          titleStyle={{ marginTop: 20 }}
          description="Are you sure you want to block this professional from working with you?"
          leftButtonText="Go Back"
          leftButtonAction={() => setShowConfirmBlockPopup(false)}
          rightButtonText="Continue"
          rightButtonAction={() => {
            dispatch(blockRecentProfessional({ user: cardUser }));
            setShowConfirmBlockPopup(false);
          }}
          Icon={() => <BlockCrossIcon />}
          closePopup={() => setShowConfirmBlockPopup(false)}
        />
      )}

      {showMissingPaymentPopup && (
        <ConfirmPopup
          title="Payment Method Missing or Expired"
          description="In order to invite a professional, please add or update your preferred payment method."
          leftButtonText="Go Back"
          leftButtonAction={() => setShowMissingPaymentPopup(false)}
          rightButtonText="Add Payment"
          rightButtonAction={() => {
            setShowMissingPaymentPopup(false);
            history.push(routes.paymentInformation);
          }}
          closePopup={() => setShowMissingPaymentPopup(false)}
          Icon={() => <img src={WarningIcon} alt="Warning" style={{ marginBottom: 21 }} />}
        />
      )}
    </Row>
  );
};
